import { DeleteOutlined } from '@ant-design/icons';
import { Button, Flex } from "antd";
import { observer } from "mobx-react";
import Subjects from '../../models/subjects';
import ITask from "../../models/task";
import { useStore } from '../../stores/root-store';

const NewTicketTaskItem: React.FC<{task: ITask, subject: Subjects}> = ({task, subject}) => {

    const { subjectStores } = useStore();
    const newTicket = subjectStores[subject].newTicket;
    const ticketBar = subjectStores[subject].ticketBar;

    const handleDelete = () => {
        newTicket.deleteTaskFromList(task.id, ticketBar);
    }

    return (
        <Flex align="center">
            <div>[{task.source.name}][{task.theme.name}]{task.withSolution ? "[Есть решение]" : ""}</div>
            <Button type="link" icon={<DeleteOutlined />} shape="circle" title="Убрать из варианта" onClick={handleDelete} />
        </Flex>
    );
}

export default observer(NewTicketTaskItem);